/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I convert years and dates?`)
};

const es_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo convertir años y fechas?`)
};

const de_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich Jahre und Datumsangaben umrechnen?`)
};

const nl_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik jaren en data converteren?`)
};

const fr_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je convertir des années et des dates ?`)
};

const it_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso convertire anni e date?`)
};

const pt_br2_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso converter anos e datas?`)
};

const pt_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso converter anos e datas?`)
};

const ja_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年と日付を変換できますか?`)
};

const zh_rn_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以转换年份和日期吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_faq4_q", locale)
	if (locale === "en") return en_rn_faq4_q(inputs)
	if (locale === "es") return es_rn_faq4_q(inputs)
	if (locale === "de") return de_rn_faq4_q(inputs)
	if (locale === "nl") return nl_rn_faq4_q(inputs)
	if (locale === "fr") return fr_rn_faq4_q(inputs)
	if (locale === "it") return it_rn_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_rn_faq4_q(inputs)
	if (locale === "pt") return pt_rn_faq4_q(inputs)
	if (locale === "ja") return ja_rn_faq4_q(inputs)
	return zh_rn_faq4_q(inputs)
};